export default "/images/image_1.jpg?73eb7cf88e356e1c98494bc4947ad4e9";